var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageShell',{staticClass:"page-shell-wrapper--pc",attrs:{"locale":"id","page-title":_vm.pageTitle}},[_c('PcContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }